import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    name: "Budi Santoso",
    role: "Owner Workshop Signage",
    city: "Surabaya",
    initials: "BS",
    rating: 5,
    quote: "Kualitas acrylic ANIMAX konsisten dari batch ke batch. Kejernihannya premium, cocok untuk huruf timbul dan signage klien kami. Pengiriman ke Surabaya juga selalu tepat waktu.",
  },
  {
    name: "Dewi Kartika",
    role: "Interior Designer",
    city: "Jakarta",
    initials: "DK",
    rating: 5,
    quote: "Sudah beberapa proyek residensial saya pakai ANIMAX untuk partisi dan aksen furniture. Warnanya solid, permukaannya halus, dan tim mereka responsif saat konsultasi spesifikasi.",
  },
  {
    name: "Ahmad Rizki",
    role: "Kontraktor Proyek",
    city: "Malang",
    initials: "AR",
    rating: 5,
    quote: "Order kami skala besar untuk proyek retail. ANIMAX bisa handle volume, packaging aman sampai lokasi, dan harganya sangat kompetitif untuk kualitas ini. Rekomended.",
  },
  {
    name: "Siti Rahmawati",
    role: "Pemilik Toko Bahan Bangunan",
    city: "Semarang",
    initials: "SR",
    rating: 5,
    quote: "Sebagai pemilik toko bahan bangunan, saya membutuhkan partner yang stabil dan bisa dipercaya. PT. Animax Putra Lancar memberikan itu: stok tersedia, komunikasi lancar, dan kerja sama jangka panjang.",
  },
  {
    name: "Yoga Pratama",
    role: "Pemilik Laser Cutting Service",
    city: "Yogyakarta",
    initials: "YP",
    rating: 5,
    quote: "Untuk laser cutting, kejernihan tepi hasil potong sangat menentukan. ANIMAX memberikan hasil potong yang bersih tanpa gelembung. Sudah jadi pilihan utama workshop kami.",
  },
  {
    name: "Linda Wijaya",
    role: "Owner Display Store",
    city: "Bandung",
    initials: "LW",
    rating: 5,
    quote: "Display etalase toko kami pakai ANIMAX Acrylic. Sudah 2 tahun terpasang di outdoor, tetap jernih dan tidak menguning. UV protection-nya memang bekerja.",
  },
];

export const Testimonials = () => {
  return (
    <section id="testimoni" data-testid="testimonials-section" className="testimonials-section py-14 sm:py-16 lg:py-20 bg-white border-y border-neutral-200 relative overflow-hidden">
      <div className="testimonials-section__glow absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full" />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 sm:gap-6 mb-8 sm:mb-10">
          <div className="max-w-2xl">
            <div className="tag-uppercase text-animax-orange mb-3 sm:mb-4">Testimoni Customer</div>
            <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-animax-black leading-tight">
              Dipercaya oleh Profesional di Seluruh Indonesia
            </h2>
          </div>
          <div className="flex items-center gap-6">
            <div>
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-animax-yellow text-animax-yellow" />
                ))}
              </div>
              <div className="mt-2 text-sm text-neutral-600">Rating 4.9/5 dari mitra kami</div>
            </div>
          </div>
        </div>

        <div className="-mx-5 px-5 sm:mx-0 sm:px-0 flex gap-4 sm:gap-5 overflow-x-auto snap-x snap-mandatory pb-2">
          {testimonials.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="card-lift group shrink-0 w-[82vw] sm:w-[22rem] lg:w-[25rem] snap-start p-5 sm:p-6 rounded-xl sm:rounded-2xl bg-white border border-[#ead6d8] hover:border-[#e60012]/45 relative"
            >
              <Quote className="absolute top-5 right-5 sm:top-6 sm:right-6 w-6 h-6 sm:w-8 sm:h-8 text-[#e60012]/20 group-hover:text-[#e60012] transition-colors" />

              <div className="flex items-center gap-1 mb-3 sm:mb-4">
                {[...Array(t.rating)].map((_, s) => (
                  <Star key={s} className="w-3.5 h-3.5 fill-animax-yellow text-animax-yellow" />
                ))}
              </div>

              <p className="text-sm text-neutral-700 leading-relaxed">&ldquo;{t.quote}&rdquo;</p>

              <div className="mt-4 pt-4 border-t border-neutral-100 flex items-center gap-3">
                <div className="w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-gradient-to-br from-[#e60012] to-[#ff6873] flex items-center justify-center text-white font-display font-semibold text-xs sm:text-sm">
                  {t.initials}
                </div>
                <div>
                  <div className="font-medium text-animax-black text-sm">{t.name}</div>
                  <div className="text-xs text-neutral-500">{t.role} · {t.city}</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-4 sm:flex sm:flex-wrap items-start sm:items-center justify-center gap-2 sm:gap-8">
          {[
            { label: "Rating Kepuasan", value: "4.9/5" },
            { label: "Mitra Aktif", value: "50+" },
            { label: "Kota Pengiriman", value: "15+" },
            { label: "Repeat Order", value: "90%" },
          ].map((s, i) => (
            <div key={i} className="text-center px-1 sm:px-6" data-testid={`testimonial-stat-${i}`}>
              <div className="font-display text-xl sm:text-3xl lg:text-4xl font-medium text-animax-black">{s.value}</div>
              <div className="tag-uppercase text-[9px] sm:text-[0.7rem] text-neutral-500 mt-1">{s.label}</div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-neutral-600" data-testid="testimonial-shipping-note">
          Melayani pengiriman ke <strong className="text-animax-black">seluruh Indonesia</strong>
        </p>
      </div>
    </section>
  );
};
